import _ from 'lodash';

const deliveryTypesByLanguage = (state) => (lang)=> {
  let deliveryTypesByLanguage = [];
  _.forEach(state.deliveryTypes, type=>{
      _.forEach(type.languages, typeLanguage=>{
        if(typeLanguage.code==lang){
          deliveryTypesByLanguage.push({id:type.id, name:typeLanguage.delivery_type_language.name, choice_custom_info:type.choice_custom_info});
        }
      })
  })
  return deliveryTypesByLanguage;
};

const deliveryTypeByLanguage = (state) => ({lang, id})=> {
  let deliveryTypeByLanguage = null;
  _.forEach(state.deliveryTypes, type=>{
    if(type.id==id){
      _.forEach(type.languages, typeLanguage=>{
        if(typeLanguage.code==lang){
          deliveryTypeByLanguage = {id:type.id, name:typeLanguage.delivery_type_language.name, choice_custom_info:type.choice_custom_info};
        }
      })
    }

  })
  return deliveryTypeByLanguage;
};


const onlinePaymentMethods = (state) => {
  return _.filter(state.paymentMethods, p => p.type === 1);
}

const adminPaymentMethods = (state) => {
  return _.filter(state.paymentMethods, p => p.type === 0);
}

const isScheduleDeliveryDayException = (state) => (day) =>{
  let exceptionFound = _.find(state.deliveryScheduleExceptions.fixedDays, d=>{return d==day});
  return exceptionFound!=null;
}

const getCustomerClassById = (state) => (id) => {
  return _.find(state.customerClasses, c => c.id === id);
}

const gl_account_name = (state) => (gl_account) =>{
  return gl_account.name + "("+gl_account.number+")";
}

const isCMSModuleActivated = (state) => {
  if(state.cmsConfiguration==null)return false;
  return state.cmsConfiguration.value.active!=null ? state.cmsConfiguration.value.active : false;
}

const isMultiAgencyModuleActivated = (state) => {
  if(state.multiAgencyConfiguration==null)return false;
  return state.multiAgencyConfiguration.value.active!=null ? state.multiAgencyConfiguration.value.active : false;
}


const getCustomGlAccounts = (state) => {
  return _.filter(state.gl_accounts, (gl) => gl.system==false)
}

const getGlAccountsByCompanyId = (state) => {
  return _.groupBy(state.gl_accounts, 'portausCompanyId');
}

const getGlSalesAccountsByCompanyId = (state) => {
  return _.groupBy(_.filter(state.gl_accounts, acc => _.get(acc, 'type.code') === 'REVENUES'), 'portausCompanyId');
}

const getCreditNoteTypesByCompanyId = (state) => {
  return _.groupBy(state.credit_note_types, 'fk_portaus_company_id');
}

const invoiceNoticeEmailCustomContent = (state) => {
  return _.filter(state.emailCustomContentData, (ecc) => { return ecc.type.code === 'INVOICE_NOTICE'});
}

const creditNoteNoticeEmailCustomContent = (state) => {
  return _.filter(state.emailCustomContentData, (ecc) => { return ecc.type.code === 'CREDIT_NOTE_NOTICE'});
}

const creditCustomerStatementNoticeEmailCustomContent = (state) => {
  return _.filter(state.emailCustomContentData, (ecc) => { return ecc.type.code === 'CUSTOMER_STATEMENT_NOTICE'});
}

const invoiceReminderEmailCustomContent = (state) => {
  return _.filter(state.emailCustomContentData, (ecc) => { return ecc.type.code === 'INVOICE_REMINDER'});
}

const getInventoriesByPortausCompany = (state) => {
  return _.groupBy(state.inventories, 'portausCompanyId');
}

const getSAQInventories = (state) => {
  return _.filter(state.inventories, inv => inv.code === 'SAQ');
}

const getPrivateImportPatriculierSAQBranch = (state) => {
  return _.filter(state.locations, location => _.get(location, 'content.succParticulier') === true || _.get(location, 'content.succParticulier') == null);
}

const getPrivateImportTPSAQBranch = (state) => {
  return _.filter(state.locations, location => _.get(location, 'content.succTP') === true  || _.get(location, 'content.succParticulier') == null);
}

const getFormattedPrivateImportPatriculierSAQBranch = (state) => {
  const branches =  _.filter(state.locations, location => _.get(location, 'content.succParticulier') === true || _.get(location, 'content.succParticulier') == null);
  return _.map(branches, b => ({ id: b.id, content: b.content, formated : `${b.content.number} - ${b.content.address} - ${b.content.city}`}))
}

const getFormattedPrivateImportTPSAQBranch = (state) => {
  const branches =  _.filter(state.locations, location => _.get(location, 'content.succTP') === true  || _.get(location, 'content.succParticulier') == null);
  return _.map(branches, b => ({ id: b.id, content: b.content, formated : `${b.content.number} - ${b.content.address} - ${b.content.city}`}))
}

export default {
  getPrivateImportPatriculierSAQBranch,
  getPrivateImportTPSAQBranch,
  getCreditNoteTypesByCompanyId,
  getInventoriesByPortausCompany,
  invoiceNoticeEmailCustomContent,
  invoiceReminderEmailCustomContent,
  deliveryTypesByLanguage,
  deliveryTypeByLanguage,
  onlinePaymentMethods,
  adminPaymentMethods,
  isScheduleDeliveryDayException,
  gl_account_name,
  isCMSModuleActivated,
  getCustomGlAccounts,
  getGlAccountsByCompanyId,
  getGlSalesAccountsByCompanyId,
  isMultiAgencyModuleActivated,
  getSAQInventories,
  getCustomerClassById,
  getFormattedPrivateImportPatriculierSAQBranch,
  getFormattedPrivateImportTPSAQBranch,
  creditNoteNoticeEmailCustomContent,
  creditCustomerStatementNoticeEmailCustomContent
};
